import React, { useEffect, useState } from 'react'
import GatewayType from '../GatewayType'
import Proxies, { ProxyRuntimeFlipCard } from './Proxies'
import WebServices from './WebServices'
import Authorization from '../../Authentication/Authorization'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import ProtectedRoute from '../../components/ProtectedRoute'
import MssqlDatabaseService from '../../../adapter/mssql/service/MssqlDatabaseService'
import MssqlAdapter from '../../../adapter/mssql/pages/MssqlAdapter'
import Loading from '../../layout/Loading'
import AppService from '../../service/AppService'

const baseRoute = '/services'

const Services: GatewayType = () => {
  const match = useRouteMatch()
  const [subTabs, setSubTabs] = useState([] as any[])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getSubTabs()
      .then((subTabs) => setSubTabs(subTabs))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Loading isLoading={loading}>
      <Switch>
        {subTabs.map((tab) => (
          <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
        ))}
        <Route path={match.path}>
          <ProxyRuntimeFlipCard size='xl' />
        </Route>
      </Switch>
    </Loading>
  )
}

async function getSubTabs(): Promise<any[]> {
  var subTabs = [
    { path: baseRoute + '/proxies', title: 'Proxies', permissions: Authorization.services.proxies.view, component: Proxies },
  ]
  try {
    const webService = await AppService.getAppsByTemplate("de.eperi.testdata.soap")
    if (webService.length > 0) {
      subTabs.push({ path: baseRoute + '/webServices', title: 'Web Services', permissions: Authorization.services.webServices, component: WebServices })

    }
  } catch (ignored) { }

  try {
    await MssqlDatabaseService.getPrimaryDatabase()
    subTabs.push({ path: baseRoute + '/adaptermssql', title: 'MSSQL', permissions: Authorization.services.mssql.view, component: MssqlAdapter })
  } catch (ignored) { }
  return subTabs
}

Services.subTabs = getSubTabs

export default Services
